import { render, staticRenderFns } from "./border-block.vue?vue&type=template&id=34f83e68&"
import script from "./border-block.vue?vue&type=script&lang=js&"
export * from "./border-block.vue?vue&type=script&lang=js&"
import style0 from "./border-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports